import cx from 'classnames';
import { photoUrl } from 'mk/photo/photoUrl';
import { Img } from 'mk2/components/Img';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ProductPhoto.mscss';

interface OwnProps {
    className?: string;
    photo: PhotoEntity;
    alt: string;

    /** If true, image is loaded only if it comes to viewport */
    lazy?: boolean;

    imgRef?(ref: HTMLImageElement);
    onLoad?();
}

type Props = OwnProps;

const ProductPhoto = React.memo<Props>(({ className, photo, alt, lazy, imgRef, onLoad }) => {
    const hasBig = photo.versions.includes('s1600x1600');

    const smallUrl = photoUrl(photo, 's460xn');
    const bigUrl = photoUrl(photo, 's1600x1600');

    return (
        <div className={cx(styles.ProductPhoto, className)}>
            <Img
                className={styles.ProductPhoto__image}
                src={smallUrl}
                alt={alt}
                onLoad={onLoad}
                width={photo.width}
                height={photo.height}
                imgRef={imgRef}
                lazy={lazy}
            />
            {hasBig && <a className={styles.ProductPhoto__big} target="_blank" href={bigUrl} />}
        </div>
    );
});

ProductPhoto.displayName = 'ProductPhoto';

export default ProductPhoto;
